var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addCode" },
    [
      _c(
        "custom-box",
        {
          class: { "mobile-custom-box": _vm.isMobile },
          attrs: {
            title: _vm.isUpd
              ? _vm.$t("modifyGroupServer")
              : _vm.$t("addGroupServer"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              class: { "mobile-form": _vm.isMobile },
              attrs: {
                "label-position": "left",
                model: _vm.paramsData,
                rules: _vm.rules,
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "server_channel",
                    label: _vm.$t("serverChannel")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.isUpd,
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("serverChannel")
                      },
                      on: { change: _vm.serverChange },
                      model: {
                        value: _vm.server_channel,
                        callback: function($$v) {
                          _vm.server_channel = $$v
                        },
                        expression: "server_channel"
                      }
                    },
                    _vm._l(_vm.serverChannel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "show_test", label: _vm.$t("showTestServer") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.isUpd,
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("showTestServer")
                      },
                      on: { change: _vm.serverChannelChange },
                      model: {
                        value: _vm.show_test,
                        callback: function($$v) {
                          _vm.show_test = $$v
                        },
                        expression: "show_test"
                      }
                    },
                    _vm._l(_vm.serverType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "serverID", label: _vm.$t("server") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        filterable: "",
                        placeholder: _vm.$t("server")
                      },
                      on: { change: _vm.severChange },
                      model: {
                        value: _vm.serverID,
                        callback: function($$v) {
                          _vm.serverID = $$v
                        },
                        expression: "serverID"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          key: "001",
                          on: { change: _vm.selectAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                      ),
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: "" + item.serverName,
                            value: item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "groupID", label: _vm.$t("groupId") }
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isUpd,
                      placeholder: _vm.$t("pleaseInputNumber"),
                      type: "number"
                    },
                    model: {
                      value: _vm.paramsData.groupID,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "groupID", $$v)
                      },
                      expression: "paramsData.groupID"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "groupName", label: _vm.$t("groupName") }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.groupName,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "groupName", $$v)
                      },
                      expression: "paramsData.groupName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "pkgs", label: _vm.$t("packageName") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectPackageName")
                      },
                      model: {
                        value: _vm.paramsData.pkgs,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "pkgs", $$v)
                        },
                        expression: "paramsData.pkgs"
                      }
                    },
                    _vm._l(_vm.pkgList, function(item) {
                      return _c("el-option", {
                        key: item.pkg,
                        attrs: { label: "" + item.pkg, value: item.pkg }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("reset")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }